import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import InfoSettings from "../../components/settings/InfoSettings";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import DescriptionDialog from "../../components/settings/DescriptionDialog";
import { languages } from "../../constants/languages";
import ChatURLDialog from "../../components/settings/ChatURLDialog";
import UpgradeDialog from "../../components/UpgradeDialog";
import PinnedMessageDialog from "../../components/settings/PinnedMessageDialog";

class InfoSettingsContainer extends Component {
  state = {
    upgradeDialogOpen: false,
    description: EditorState.createEmpty(),
    descriptionDialogOpen: false,
    tr: null,

    chatURL: "",
    chatURLDialogOpen: false,

    pinnedMessageDialogOpen: false,
    pinnedMessageTitle: "",
    pinnedMessage: "",
  };

  componentDidMount = () => {
    let newState = { chatURL: this.props.tournament.chatURL || "" };
    let descriptionHTML = this.props.tournament.description || "";
    const contentBlock = htmlToDraft(descriptionHTML);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      newState["description"] = editorState;
    }

    languages.getAvailableLanguages().forEach((lang) => {
      let descriptionHTML = this.props.tournament["description" + lang] || "";
      const contentBlock = htmlToDraft(descriptionHTML);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const editorState = EditorState.createWithContent(contentState);
        newState["description" + lang] = editorState;
      }
    });

    this.setState(newState);
  };

  toggleUpgradeDialog = () => {
    this.setState({
      upgradeDialogOpen: !this.state.upgradeDialogOpen,
    });
  };

  handleBack = () => {
    this.props.history.push("/tournament/" + this.props.tournament[".key"]);
  };

  handleDescriptionTrChange = (tr) => {
    this.setState({ tr: tr });
  };
  toggleDescriptionDialog = () => {
    let allowedToAddDescription = true;
    if (
      this.props.tournamentStatus.status === 1 ||
      this.props.tournamentStatus.status === 2 ||
      this.props.tournamentStatus.status === 3 ||
      this.props.userStatus.status === 1 ||
      this.props.userStatus.status === 2 ||
      this.props.userStatus.status === 3
    ) {
      allowedToAddDescription = true;
    }
    if (allowedToAddDescription) {
      this.setState({
        descriptionDialogOpen: !this.state.descriptionDialogOpen,
      });
    } else {
      this.toggleUpgradeDialog();
    }
  };
  handleDescriptionChange = (editorState) => {
    let toUpdate = {};
    toUpdate["description" + (this.state.tr ? this.state.tr : "")] =
      editorState;
    this.setState(toUpdate);
  };
  handleSubmitDescription = (e) => {
    e.preventDefault();

    let toUpdate = {};
    toUpdate["description" + (this.state.tr ? this.state.tr : "")] =
      draftToHtml(
        convertToRaw(
          this.state[
            "description" + (this.state.tr ? this.state.tr : "")
          ].getCurrentContent()
        )
      );

    let allowedToAddLinks = false;
    if (
      this.props.tournamentStatus.status === 1 ||
      this.props.tournamentStatus.status === 2 ||
      this.props.tournamentStatus.status === 3 ||
      this.props.userStatus.status === 1 ||
      this.props.userStatus.status === 2 ||
      this.props.userStatus.status === 3
    ) {
      allowedToAddLinks = true;
    }
    const descriptionContainsLinks = draftToHtml(
      convertToRaw(
        this.state[
          "description" + (this.state.tr ? this.state.tr : "")
        ].getCurrentContent()
      )
    ).includes("<a");

    if (!allowedToAddLinks && descriptionContainsLinks) {
      this.toggleUpgradeDialog();
    } else {
      this.toggleDescriptionDialog();
      window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .update(toUpdate);
    }
  };

  toggleChatURLDialog = () => {
    this.setState({ chatURLDialogOpen: !this.state.chatURLDialogOpen });
  };
  handleChatURLChange = (e) => {
    let chatURL = e.target.value;
    this.setState({ chatURL: chatURL });
  };
  handleSubmitChatURL = (e) => {
    e.preventDefault();
    this.toggleChatURLDialog();
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({ chatURL: this.state.chatURL });
  };

  handleCombineSponsorsChange = (e) => {
    let checked = e.target.checked;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update({ combineSponsors: checked });
  };

  togglePinnedMessageDialog = () => {
    if (!this.state.pinnedMessageDialogOpen) {
      // Load existing values when opening
      this.setState({
        pinnedMessageTitle: this.props.tournament.pinnedMessageTitle || "",
        pinnedMessage: this.props.tournament.pinnedMessage || "",
      });
    }
    this.setState({
      pinnedMessageDialogOpen: !this.state.pinnedMessageDialogOpen,
    });
  };

  handlePinnedMessageTitleChange = (e) => {
    this.setState({ pinnedMessageTitle: e.target.value });
  };

  handlePinnedMessageChange = (e) => {
    this.setState({ pinnedMessage: e.target.value });
  };

  handleSubmitPinnedMessage = (e) => {
    e.preventDefault();

    const toUpdate = {
      pinnedMessageTitle: this.state.pinnedMessageTitle,
      pinnedMessage: this.state.pinnedMessage,
      pinnedMessageTimestamp: new Date(),
    };

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate)
      .then(() => {
        this.togglePinnedMessageDialog();
      });
  };

  handleDeletePinnedMessage = () => {
    const toUpdate = {
      pinnedMessageTitle: null,
      pinnedMessage: null,
      pinnedMessageTimestamp: null,
    };

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  render() {
    let descriptionHTML =
      this.props.tournament[
        "description" + (this.state.tr ? this.state.tr : "")
      ] || "";
    const contentBlock = htmlToDraft(descriptionHTML);

    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    );
    const editorState = EditorState.createWithContent(contentState);
    let currentTournamentDescriptionState = editorState;

    let combineSponsors = this.props.tournament.combineSponsors;
    if (combineSponsors === undefined) {
      if (this.props.tournament.vrsn >= 7) {
        combineSponsors = false;
      } else {
        combineSponsors = true;
      }
    }

    return (
      <div>
        <UpgradeDialog
          open={this.state.upgradeDialogOpen}
          toggleDialog={this.toggleUpgradeDialog}
          title={languages.upgrade.upgradeTournament}
          description={languages.upgrade.upgradeTextDesign}
          tournament={this.props.tournament}
          user={this.props.user}
          userData={this.props.userData}
          tournamentStatus={this.props.tournamentStatus}
        />
        <DescriptionDialog
          open={this.state.descriptionDialogOpen}
          description={
            this.state.tr
              ? this.state["description" + this.state.tr]
              : this.state.description
          }
          toggleDialog={this.toggleDescriptionDialog}
          handleDescriptionChange={this.handleDescriptionChange}
          handleSubmit={this.handleSubmitDescription}
          title={languages.tournament.description}
          tr={this.state.tr}
          userStatus={this.props.userStatus}
          tournamentStatus={this.props.tournamentStatus}
        />
        <ChatURLDialog
          open={this.state.chatURLDialogOpen}
          chatURL={this.state.chatURL}
          toggleDialog={this.toggleChatURLDialog}
          handleChatURLChange={this.handleChatURLChange}
          handleSubmit={this.handleSubmitChatURL}
          title={languages.tournament.chatURL}
        />
        <PinnedMessageDialog
          open={this.state.pinnedMessageDialogOpen}
          toggleDialog={this.togglePinnedMessageDialog}
          title={this.state.pinnedMessageTitle}
          message={this.state.pinnedMessage}
          handleTitleChange={this.handlePinnedMessageTitleChange}
          handleMessageChange={this.handlePinnedMessageChange}
          handleSubmit={this.handleSubmitPinnedMessage}
        />
        <InfoSettings
          tournament={this.props.tournament}
          handleBack={this.handleBack}
          currentTournamentDescriptionState={currentTournamentDescriptionState}
          // description={this.state.description}
          toggleDescriptionDialog={this.toggleDescriptionDialog}
          user={this.props.user}
          toggleChatURLDialog={this.toggleChatURLDialog}
          userData={this.props.userData}
          userStatus={this.props.userStatus}
          tournamentStatus={this.props.tournamentStatus}
          tr={this.state.tr}
          handleDescriptionTrChange={this.handleDescriptionTrChange}
          combineSponsors={combineSponsors}
          handleCombineSponsorsChange={this.handleCombineSponsorsChange}
          pinnedMessageTitle={this.props.tournament.pinnedMessageTitle}
          pinnedMessage={this.props.tournament.pinnedMessage}
          togglePinnedMessageDialog={this.togglePinnedMessageDialog}
          handleDeletePinnedMessage={this.handleDeletePinnedMessage}
        />
      </div>
    );
  }
}

export default withRouter(InfoSettingsContainer);
